import { render, staticRenderFns } from "./EventListv2.vue?vue&type=template&id=32514b4c&"
import script from "./EventListv2.vue?vue&type=script&lang=js&"
export * from "./EventListv2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports